export default __webpack_public_path__ + "static/media/moon-o.c1742830.svg";